/**
 *
 * Asynchronously loads the component for HealthSystemRedirectionPage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
